<template>
    <v-skeleton-loader
        type="card"
    ></v-skeleton-loader>
</template>
<script>
export default {
    name: "ReservationCardSkeleton"
}
</script>